import { create } from 'zustand';

interface UserData {
  id: string;
  username: string;
  level: 'member' | 'admin' | 'system';
  permissions: string[];
}

interface AuthState {
  user: UserData | null;
  token: string | null;
  setUser: (user: UserData | null, token: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: null,
  setUser: (user, token) => set({ user, token }),
  logout: () => set({ user: null, token: null }),
}));
